import { h, render } from 'preact';
import { Footer } from '../components/footer.js';
import { ClientInit } from '../../common/types.js';

export function initFooter(footer: HTMLElement, init: ClientInit) {
	render(h(Footer, { menuCache: init.menuCache, content: init.footer }), footer.parentElement!, footer);
}
